import { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"
import { setPreview } from "../store/reducers/general.js"
import { rolesTranslations } from "../services/data.js"
import { NoThumbnail } from "./no-thumbnail.jsx"

export function VideoCard({ video, className, displayRole = true }) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector(state => state.user)
    const { currentTeam } = user
    const { titles, thumbnails } = video.ideaMaker

    var findResponsible = () => {
        if (!currentTeam.members) return 'לא ידוע'
        if (video.status.workerId) return currentTeam.members.find(worker => worker._id === video.status.workerId)?.name || 'לא ידוע'
        return video.status.departmentName || 'לא ידוע'
    }

    const workerName = useRef(findResponsible())
    return <div className={`video-card ${className}`} onClick={() => navigate(`/video/${video._id}`)}>
        {(video.lastViewed?.[user._id] && new Date(video.lastViewed?.[user._id]) < new Date(video.updatedAt)) && <span className="new-badge">חדש</span>}
       {thumbnails[0] ? <img src={thumbnails[0]} alt={titles[0].url} className="thumbnail" /> : <NoThumbnail />}
        <div className="lower" >
            <img src={currentTeam.channelImage} />
            <div className="details" >
                <h3>{titles[0]}</h3>
                {(video.status.level !== 'archived') && <p>{displayRole && rolesTranslations[video.status.level] + ' - '}{workerName.current}
                    <span className={video.workDays > 30 ? 'red-text' : video.workDays > 10 ? 'yellow-text' : ''}>{video.workDays && ' (' + video.workDays + ' ימים)'}</span></p>}
            </div>
            <span onClick={(e) => { e.stopPropagation(); dispatch(setPreview([video])) }} className="material-symbols-outlined preview-btn">visibility</span>
        </div>
    </div>
}
